import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  MASTER_THIRD_PARTY_PRICING_LIST,
  MASTER_THIRD_PARTY_PRICING_CREATE,
  MASTER_THIRD_PARTY_PRICING_UPDATE,
  MASTER_THIRD_PARTY_PRICING_DELETE,
} from "./actionType";

import {
  masterThirdPartyPricingListSuccess,
  masterThirdPartyPricingListFailure,
  masterThirdPartyPricingCreateSuccess,
  masterThirdPartyPricingCreateFailure,
  masterThirdPartyPricingUpdateSuccess,
  masterThirdPartyPricingUpdateFailure,
  masterThirdPartyPricingDeleteSuccess,
  masterThirdPartyPricingDeleteFailure,
} from "./action";

import {
  getMasterThirdPartyPricingList,
  createMasterThirdPartyPricing,
  updateMasterThirdPartyPricing,
  deleteMasterThirdPartyPricing,
} from "../../helpers/fakebackend_helper";

// LIST
function* fetchMasterThirdPartyPricingList() {
  try {
    const response = yield call(getMasterThirdPartyPricingList);
    yield put(masterThirdPartyPricingListSuccess(response));
  } catch (error) {
    yield put(masterThirdPartyPricingListFailure(error));
  }
}
function* watchFetchMasterThirdPartyPricingList() {
  yield takeEvery(MASTER_THIRD_PARTY_PRICING_LIST, fetchMasterThirdPartyPricingList);
}

// CREATE
function* createMasterThirdPartyPricingSaga(action) {
  try {
    const response = yield call(createMasterThirdPartyPricing, action.payload);
    yield put(masterThirdPartyPricingCreateSuccess(response));
  } catch (error) {
    yield put(masterThirdPartyPricingCreateFailure(error));
  }
}
function* watchCreateMasterThirdPartyPricing() {
  yield takeEvery(MASTER_THIRD_PARTY_PRICING_CREATE, createMasterThirdPartyPricingSaga);
}

// UPDATE
function* updateMasterThirdPartyPricingSaga(action) {
  try {
    const response = yield call(updateMasterThirdPartyPricing, action.payload);
    yield put(masterThirdPartyPricingUpdateSuccess(response));
  } catch (error) {
    yield put(masterThirdPartyPricingUpdateFailure(error));
  }
}
function* watchUpdateMasterThirdPartyPricing() {
  yield takeEvery(MASTER_THIRD_PARTY_PRICING_UPDATE, updateMasterThirdPartyPricingSaga);
}

// DELETE
function* deleteMasterThirdPartyPricingSaga(action) {
  try {
    const response = yield call(deleteMasterThirdPartyPricing, action.payload);
    yield put(masterThirdPartyPricingDeleteSuccess(response));
  } catch (error) {
    yield put(masterThirdPartyPricingDeleteFailure(error));
  }
}
function* watchDeleteMasterThirdPartyPricing() {
  yield takeEvery(MASTER_THIRD_PARTY_PRICING_DELETE, deleteMasterThirdPartyPricingSaga);
}

export default function* masterThirdPartyPricingSaga() {
  yield all([
    fork(watchFetchMasterThirdPartyPricingList),
    fork(watchCreateMasterThirdPartyPricing),
    fork(watchUpdateMasterThirdPartyPricing),
    fork(watchDeleteMasterThirdPartyPricing),
  ]);
}
